import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import './CompactPagination.css';

const CompactPagination = ({ 
  totalItems, 
  itemsPerPage, 
  currentPage, 
  onPageChange,
  className = '',
  maxVisiblePages = 3
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  
  // Don't render pagination if there's only one page or no items
  if (totalPages <= 1) {
    return null;
  }

  // Calculate which page numbers to show (only 2-3 pages)
  const getVisiblePages = () => {
    const pages = [];
    
    if (totalPages <= maxVisiblePages) {
      // Show all pages if total is less than max visible
      for (let i = 0; i < totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Show only 2-3 pages with ellipsis
      if (currentPage === 0) {
        // First page
        pages.push(0);
        pages.push(1);
        if (totalPages > 2) {
          pages.push('ellipsis');
          pages.push(totalPages - 1);
        }
      } else if (currentPage === totalPages - 1) {
        // Last page
        pages.push(0);
        pages.push('ellipsis');
        pages.push(totalPages - 2);
        pages.push(totalPages - 1);
      } else {
        // Middle page
        pages.push(0);
        pages.push('ellipsis');
        pages.push(currentPage);
        pages.push('ellipsis');
        pages.push(totalPages - 1);
      }
    }
    
    return pages;
  };

  const visiblePages = getVisiblePages();

  const handlePageClick = (page) => {
    if (page >= 0 && page < totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div className={`compact-pagination-container ${className}`}>
      <Pagination size="sm" className="justify-content-center mb-0">
        {/* Previous Page */}
        <PaginationItem disabled={currentPage === 0}>
          <PaginationLink 
            previous 
            onClick={() => handlePageClick(currentPage - 1)}
            className={currentPage === 0 ? 'disabled' : ''}
          />
        </PaginationItem>

        {/* Page Numbers */}
        {visiblePages.map((page, index) => (
          <PaginationItem key={index} active={page === currentPage}>
            {page === 'ellipsis' ? (
              <PaginationLink className="ellipsis">
                ...
              </PaginationLink>
            ) : (
              <PaginationLink onClick={() => handlePageClick(page)}>
                {page + 1}
              </PaginationLink>
            )}
          </PaginationItem>
        ))}

        {/* Next Page */}
        <PaginationItem disabled={currentPage === totalPages - 1}>
          <PaginationLink 
            next 
            onClick={() => handlePageClick(currentPage + 1)}
            className={currentPage === totalPages - 1 ? 'disabled' : ''}
          />
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default CompactPagination; 